var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"edit_booking_button button solid small",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleEditBooking()}}},[_c('i',{staticClass:"fal fa-edit"}),_c('span',[_vm._v("Edit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }